const sectionReader = {
    shouldShowVericalDisplay(section, sessionReader, currentQuestion) {
        if (currentQuestion && currentQuestion.layout) {
            return false;
        }
        if (section.layout && section.layout.includes('vertical')) {
            return true;
        }
        return (sessionReader.isModeSection() || sessionReader.isModeQuestionSet()) && !!section.stimulusContent;
    },
};

export default sectionReader;
